export default "__VITE_ASSET__a275f437__"